import React from 'react';
import { Outlet } from 'react-router-dom';

export const AuthLayout: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-500 to-purple-600">
      <div className="w-full max-w-md p-8 bg-white dark:bg-gray-800 rounded-2xl shadow-2xl">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-gray-800 dark:text-white">项目管理系统</h1>
          <p className="text-gray-500 dark:text-gray-400 mt-2">软件开发项目协作平台</p>
        </div>
        <Outlet />
      </div>
    </div>
  );
};
